
import { Menu } from "antd";

import { BarsOutlined, DashboardFilled, KeyOutlined, UserOutlined } from "@ant-design/icons";

import { NavLink } from "react-router-dom";

import imageDWH from '../assets/images/data-warehouse.png';

function Sidenav() {

    const menuItems = [
        {
            key: "1",
            label: (
                <NavLink to="/dashboard">
                    <span className="icon">
                        <DashboardFilled style={{ fontSize: '20px' }} />
                    </span>
                    <span className="label">Dashboard</span>
                </NavLink>
            ),
        },
        {
            key: "2",
            label: (
                <NavLink to="/Usuarios">
                    <span className="icon">
                        <UserOutlined style={{ fontSize: '20px' }} />
                    </span>
                    <span className="label">Usuarios</span>
                </NavLink>
            ),
        },
        {
            key: "3",
            label: (
                <NavLink to="/ExpedienteVirtual">
                    <span className="icon">
                        <BarsOutlined style={{ fontSize: '20px' }} />
                    </span>
                    <span className="label">Expediente <br /> Virtual</span>
                </NavLink>
            ),
        },
        {
            key: "4",
            label: (
                <NavLink to="/ConsultarExpedientes">
                    <span className="icon">
                        <BarsOutlined style={{ fontSize: '20px' }} />
                    </span>
                    <span className="label">Consultar <br /> Expedientes</span>
                </NavLink>
            ),
        },
        {
            key: "5",
            label: (
                <NavLink to="/ConsultarUsuario">
                    <span className="icon">
                        <BarsOutlined style={{ fontSize: '20px' }} />
                    </span>
                    <span className="label">Consultar <br /> Usuario</span>
                </NavLink>
            ),
        },
        {
            key: "6",
            label: (
                <NavLink to="/VisualizarDocumentos">
                    <span className="icon">
                        <BarsOutlined style={{ fontSize: '20px' }} />
                    </span>
                    <span className="label">Visualizar <br /> documentos</span>
                </NavLink>
            ),
        },
        // {
        //     key: "7",
        //     label: (
        //         <NavLink to="/Notificaciones">
        //             <span className="icon">
        //                 <SendOutlined style={{ fontSize: '20px' }} />
        //             </span>
        //             <span className="label">Notificaciones</span>
        //         </NavLink>
        //     ),
        // },
        {
            key: "8",
            label: (
                <NavLink to="/Apikeys">
                    <span className="icon">
                        <KeyOutlined style={{ fontSize: '20px' }} />
                    </span>
                    <span className="label">Api key´s</span>
                </NavLink>
            ),
        },
    ];

    return (
        <>
            <div className="brand">
                <img src={imageDWH} alt="" />
                <span>Data Warehouse</span>
            </div>

            <hr />

            <Menu theme="light" mode="inline" items={menuItems} />

        </>
    );

}

export default Sidenav;
